'use strict';exports.__esModule = true;var _extends = Object.assign || function (target) {for (var i = 1; i < arguments.length; i++) {var source = arguments[i];for (var key in source) {if (Object.prototype.hasOwnProperty.call(source, key)) {target[key] = source[key];}}}return target;};
var _react = require('react');var _react2 = _interopRequireDefault(_react);
var _propTypes = require('prop-types');var _propTypes2 = _interopRequireDefault(_propTypes);
var _reactRouter = require('react-router');
var _classnames = require('classnames');var _classnames2 = _interopRequireDefault(_classnames);
var _get = require('lodash/get');var _get2 = _interopRequireDefault(_get);

var _components = require('../../components');

var _appendLocale = require('../../helpers/appendLocale');var _appendLocale2 = _interopRequireDefault(_appendLocale);
var _checkUserAgent = require('../../utils/checkUserAgent');var _checkUserAgent2 = _interopRequireDefault(_checkUserAgent);
var _constants = require('../../constants');






var _config = require('./config');

var _Footer = require('./Footer.scss');var styles = _interopRequireWildcard(_Footer);
var _EN = require('../../../static/badge/ios/EN.svg');var _EN2 = _interopRequireDefault(_EN);
var _RU = require('../../../static/badge/ios/RU.svg');var _RU2 = _interopRequireDefault(_RU);
var _HE = require('../../../static/badge/ios/HE.svg');var _HE2 = _interopRequireDefault(_HE);
var _FR = require('../../../static/badge/ios/FR.svg');var _FR2 = _interopRequireDefault(_FR);
var _EN3 = require('../../../static/badge/android/EN.png');var _EN4 = _interopRequireDefault(_EN3);
var _RU3 = require('../../../static/badge/android/RU.png');var _RU4 = _interopRequireDefault(_RU3);
var _HE3 = require('../../../static/badge/android/HE.png');var _HE4 = _interopRequireDefault(_HE3);
var _FR3 = require('../../../static/badge/android/FR.png');var _FR4 = _interopRequireDefault(_FR3);
var _social = require('../../../static/icons/social');var _social2 = _interopRequireDefault(_social);function _interopRequireWildcard(obj) {if (obj && obj.__esModule) {return obj;} else {var newObj = {};if (obj != null) {for (var key in obj) {if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];}}newObj.default = obj;return newObj;}}function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}function _classCallCheck(instance, Constructor) {if (!(instance instanceof Constructor)) {throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self, call) {if (!self) {throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call && (typeof call === "object" || typeof call === "function") ? call : self;}function _inherits(subClass, superClass) {if (typeof superClass !== "function" && superClass !== null) {throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);}subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;} // Modules
// Components
// Helpers
// Styles
var badge = { ios: { en: _EN2.default, ru: _RU2.default, he: _HE2.default, fr: _FR2.default }, android: { en: _EN4.default, ru: _RU4.default, he: _HE4.default, fr: _FR4.default } };var


Footer = function (_Component) {_inherits(Footer, _Component);function Footer() {var _temp, _this, _ret;_classCallCheck(this, Footer);for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {args[_key] = arguments[_key];}return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.






    setTermsDefinitionsLink = function (locale, links) {
      var updatedLinks = [].concat(links);
      if (_this.props.locale === _constants.language.default) {
        if (!updatedLinks.includes(_constants.realEstateTermsDefinitionsLink)) {
          updatedLinks.splice(-1, 0, _constants.realEstateTermsDefinitionsLink);
        }
      } else if (updatedLinks.includes(_constants.realEstateTermsDefinitionsLink)) {
        updatedLinks.splice(-1, 1);
      }
      return updatedLinks;
    }, _this.

    getDesktopFooterLinks = function () {
      var links = [].concat(_config.desktopFooterLinks);
      return _this.setTermsDefinitionsLink(_this.props.locale, links);
    }, _this.

    getMobileFooterLink = function () {
      var links = [].concat(_config.mobileFooterLinks);
      if (_this.props.locale === 'ru') {
        var privacyLink = links.find(function (link) {return link.name === 'privacy';});
        var idx = links.indexOf(privacyLink);
        links.splice(idx, 1);
        links.push(privacyLink);
      }

      return _this.setTermsDefinitionsLink(_this.props.locale, links);
    }, _this.

    getBudge = function (os, locale) {return (0, _get2.default)(badge, os + '.' + locale);}, _this.

    isLocalizedHomePage = function (route) {return _constants.language.supportedLanguages.
      map(function (lang) {return '/' + lang + '/';}).some(function (locRoute) {return locRoute === route;});}, _this.

    isHomePage = function () {var _browserHistory$getCu =
      _reactRouter.browserHistory.getCurrentLocation(),pathname = _browserHistory$getCu.pathname;
      return pathname === '/' || _this.isLocalizedHomePage(pathname);
    }, _this.

    clickHome = function (event) {
      event.preventDefault();
      if (_this.isHomePage()) {
        return global.window.location.reload();
      }

      return _reactRouter.browserHistory.push((0, _appendLocale2.default)(_this.props.locale, '/'));
    }, _this.

    switchAppStoreButton = function (locale) {
      var buttons = {
        he: _HE2.default,
        en: _EN2.default,
        fr: _FR2.default,
        ru: _RU2.default };

      return buttons[locale];
    }, _this.

    createDesktopLinks = function () {return _this.getDesktopFooterLinks().map(function (_ref) {var name = _ref.name,link = _ref.link;return (
          _this.renderLink(link, name));});}, _this.

    renderAppLinks = function () {
      var iosLink = (!_this.props.isMobile || _this.isIOsDevice) &&
      _react2.default.createElement('a', { href: _constants.appStoreLink, target: '_blank', rel: 'nofollow noopener noreferrer' },
        _react2.default.createElement('img', { src: _this.getBudge('ios', _this.props.locale), alt: 'appStore' }));



      var androidLink = (!_this.props.isMobile || _this.isAndroidDevice) &&
      _react2.default.createElement('a', { href: _constants.playmarketLink, target: '_blank', rel: 'nofollow noopener noreferrer' },
        _react2.default.createElement('img', { src: _this.getBudge('android', _this.props.locale), alt: 'playMarket' }));



      return (
        _react2.default.createElement('div', { className: styles.appLinks },
          androidLink,

          iosLink));


    }, _this.

    renderMobileLinks = function () {
      var links = _this.getMobileFooterLink();

      return (
        _react2.default.createElement('div', { className: styles.linkWrapper },
          _react2.default.createElement('ul', { className: styles.nav },
            links.map(function (_ref2) {var name = _ref2.name,link = _ref2.link;return _this.renderLink(link, name);}))));



    }, _this.


    renderLink = function (link, name) {
      var additionalProps = { onClick: link === 'publish' ? _this.props.publishClicked : undefined };
      return (
        _react2.default.createElement(_reactRouter.Link, _extends({}, additionalProps, { key: link, to: (0, _appendLocale2.default)(_this.props.locale, '/' + link) }),
          _react2.default.createElement('div', null, _this.props.translate('footer', name))));


    }, _this.

    renderSocialLinks = function () {var linksData = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];return linksData.map(function (item) {return (
          _react2.default.createElement('a', {
              href: item.link,
              target: '_blank',
              rel: 'noopener noreferrer',
              id: item.name,
              key: item.name,
              className: styles.socialLink },

            _react2.default.createElement('img', { src: _social2.default[item.name], alt: '' })));});}, _this.



    renderDesktopSocialBlock = function () {return _this.props.displaySocial &&
      _react2.default.createElement('div', { className: styles.social, id: 'SocialBlock' },
        _react2.default.createElement('div', null,
          _this.renderSocialLinks(_config.socialLinksData)),


        _this.renderAppLinks(),

        _react2.default.createElement(_components.LanguageSwitch, {
          isRtl: _this.props.isRtl,
          locale: _this.props.locale,
          routeData: _this.props.routeData,
          isLargeIcons: true }));}, _temp), _possibleConstructorReturn(_this, _ret);}Footer.prototype.componentDidMount = function componentDidMount() {var _navigator = navigator,userAgent = _navigator.userAgent;this.isIOsDevice = !!_checkUserAgent2.default.getIOsVersion(userAgent);this.isAndroidDevice = _checkUserAgent2.default.isAndroid(userAgent);};Footer.prototype.




  render = function render() {var _cx;
    if (!this.props.isFooterShown) {
      return null;
    }

    if (this.props.isMobile) {
      switch (this.props.routeData.location) {
        case 'home_details':return null;
        case 'project_details':return null;

        default:break;}

    }

    var year = new Date().getFullYear();

    // Enforcing publish ability
    var links = this.props.isMobile ? _config.mobileFooterLinks : _config.desktopFooterLinks;
    var publishObject = links.find(function (_ref3) {var link = _ref3.link;return link === 'publish';});

    if (publishObject && !publishObject.onClick) {
      publishObject.onClick = this.props.publishClicked;
    }

    return (
      _react2.default.createElement('footer', { className: (0, _classnames2.default)(styles.footer, (_cx = {}, _cx[styles.propertyList] = this.props.inPropertiesList, _cx)) },
        _react2.default.createElement('div', { className: styles.omLogo },
          _react2.default.createElement(_reactRouter.Link, { to: (0, _appendLocale2.default)(this.props.locale, '') || '/', className: styles.logo, onClick: this.clickHome },
            _react2.default.createElement('img', {
              width: '112px',
              src: _constants.onMapLogoWhite,
              alt: '',
              title: '' + this.props.translate('header', 'onMapHomepage') }))),



        _react2.default.createElement('div', { className: styles.container },
          _react2.default.createElement('div', { className: styles.top },

            this.props.isMobile || this.props.inPropertiesList ?
            this.renderMobileLinks() :
            _react2.default.createElement('ul', { className: styles.nav }, this.createDesktopLinks())),



          (this.props.isMobile || this.props.inPropertiesList) &&
          _react2.default.createElement('div', { className: styles.mobileBlock }, this.renderAppLinks()),


          (this.props.isMobile || this.props.inPropertiesList) &&
          _react2.default.createElement('div', { className: styles.mobileBlock },
            _react2.default.createElement(_components.LanguageSwitch, {
              locale: this.props.locale,
              isRtl: this.props.isRtl,
              routeData: this.props.routeData,
              isLargeIcons: true })),




          (this.props.isMobile || this.props.inPropertiesList) &&
          _react2.default.createElement('div', { className: styles.mobileBlock }, this.renderSocialLinks(_config.socialLinksData)),


          !this.props.isMobile && !this.props.inPropertiesList &&
          this.renderDesktopSocialBlock(),

          _react2.default.createElement('div', { className: styles.copyright },
            _react2.default.createElement('p', null,
              _react2.default.createElement('span', { className: styles.copy }, '\xA9\xA0'), 'OnMap ' +
              year)))));





  };return Footer;}(_react.Component);exports.default = Footer;


Footer.propTypes = {
  locale: _propTypes2.default.string.isRequired,
  translate: _propTypes2.default.func,
  displaySocial: _propTypes2.default.bool,
  isMobile: _propTypes2.default.bool,
  publishClicked: _propTypes2.default.func.isRequired,
  isFooterShown: _propTypes2.default.bool,
  isNative: _propTypes2.default.bool,
  className: _propTypes2.default.string,
  inPropertiesList: _propTypes2.default.bool,
  isRtl: _propTypes2.default.bool,
  routeData: _propTypes2.default.object };module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Footer/Footer.js
// module id = 1204
// module chunks = 0